import { ZoneItemSetRequest } from '../ZoneService.model';

export default function newSettingToSetZone(
  newSetting: string,
  zoneIndex: string | number
): ZoneItemSetRequest {
  return { [zoneIndex]: { activeSetting: newSetting } };
}
